<template>
  <div>
    <h1 class="text-xl font-medium leading-6 text-gray-900 mr-2">Let's get some background information about you</h1>
    <p class="mt-1 text-sm text-gray-500">
      We'll use this to personalize your experience within Humaniz and to provide you with timely alerts on your account
      where possible.
    </p>

    <div v-if="loaded" class="mt-6 mb-6 grid grid-cols-1 gap-x-4 gap-y-8 max-w-sm mx-auto">
      <TextInput label="First Name" placeholder="John" :modelValue="form.firstName" />
      <TextInput label="Last Name" placeholder="Doe" :modelValue="form.lastName" />
      <PhoneInput
        label="Mobile Phone Number"
        placeholder="+1 (281) 330 8004"
        :modelValue="form.mobilePhoneNumber"
        @update:modelValue="form.mobilePhoneNumber = $event"
      />
    </div>

    <div class="py-3 flex justify-center">
      <span class="flex w-full rounded-md shadow-sm sm:w-auto">
        <TButton @click="nextStep" color="amber" label="Continue" :disabled="!profileValidated" />
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loaded: false,
      form: {
        firstName: '',
        lastName: '',
        mobilePhoneNumber: '',
      },
    };
  },
  computed: {
    ...mapState({ user: state => state.general.currentUser }),
    profileValidated() {
      return this.form.firstName !== '' && this.form.lastName !== '' && this.form.mobilePhoneNumber !== ''
        ? true
        : false;
    },
  },
  async mounted() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      await this.$store.dispatch('general/loadCurrentUser');
      this.form = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        mobilePhoneNumber: this.user?.mobilePhoneNumber ?? '',
      };
      this.loaded = true;
    },
    async nextStep() {
      await this.$store.dispatch('general/updateUser', {
        user: this.user,
        updatedUserAttributes: {
          first_name: this.form.firstName,
          last_name: this.form.lastName,
          mobile_phone_number: this.form.mobilePhoneNumber,
        },
      });
      this.$emit('go-forward');
    },
  },
};
</script>
